import styled from "@emotion/styled"
import { sizes } from "../../config"

const ModalWrapper = styled.div`
  padding: ${sizes.l};
  text-align: left;
`

export default ModalWrapper
